import * as React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

import { colors } from 'core/styles';

// tslint:disable:max-line-length
function IncreaseIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props} viewBox="0 0 20 20">
      <path
        d="M13.4142 12.1568V6.49999M7.7573 6.49999L13.4142 6.49999M13.4142 6.49999L5.49994 14.4142"
        stroke={colors.greenShamrock}
      />
    </SvgIcon>
  );
}

export { IncreaseIcon };
